// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './api/http';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import 'lib-flexible/flexible'

// 工具类
import utils from './utils/tools.js';

//引入静态资源
import './assets/css/common.css';
import global from './assets/js/global_variable.js';

// 将业务请求挂载到Vue原型上，可以全局使用
Vue.prototype.utils = utils;
Vue.prototype.global = global;
Vue.http = Vue.prototype.$axios = axios;

Vue.config.productionTip = false

Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js